export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_q03_b.a12ae2ae.png";